export class RespondConfirmation {
  inputText: string;
  answer: string;
}

export class CustomRespondConfirmation {
  respondObject:any;
  answer:string;
}